<!-- Warning -->
<div class="warning">

    <!-- Header -->
    <div mat-dialog-title>
        <div role="heading" class="warning-header">
            WARNING
        </div>
    </div>

    <!-- Body -->
    <mat-dialog-content>
        <div class="warning-body" *ngIf="noSubject">
            This email has no subject.
        </div>
        <div class="warning-body" *ngIf="noContent">
            This email has no content.
        </div>
    </mat-dialog-content>
</div>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <tyl-button image="next arrow.png" label="Send Anyway" (clickEvent)="sendAnyway()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>